import * as React from 'react';
import { useState, useEffect } from 'react';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
export function QuotesCarousel(props) {
    var quotes = props.quotes;
    var _a = useState(0), activeIndex = _a[0], updateIndex = _a[1];
    if (!quotes) {
        return null;
    }
    useEffect(function () {
        return;
    }, [activeIndex]);
    var breakpoints = {
        0: {
            spaceBetween: 20
        }
    };
    var autoplay = {
        delay: 5000
    };
    var slides = quotes.filter(function (quote) { return quote.quoteText; });
    return (React.createElement(React.Fragment, null,
        React.createElement(Swiper, { spaceBetween: 0, slidesPerView: 1, autoHeight: true, breakpoints: breakpoints, autoplay: autoplay, loop: true, modules: [Autoplay] }, slides.map(function (quote, index) {
            return React.createElement(SwiperSlide, { key: "slide-no-".concat(index + 1) },
                React.createElement(Slide, { quote: quote }));
        }))));
}
function Slide(props) {
    var quote = props.quote;
    if (!quote) {
        return null;
    }
    return (React.createElement("div", { className: 'barkfors-quote-item' },
        React.createElement("div", { className: 'quote-text' },
            React.createElement("i", { className: 'fa-solid fa-quote-left' }),
            quote.quoteText,
            React.createElement("i", { className: 'fa-solid fa-quote-right' })),
        React.createElement("div", { className: 'quote-referer' },
            React.createElement("img", { src: "".concat(quote.imageUrl, "?width=100"), width: '100', loading: 'lazy' }),
            React.createElement("div", { className: 'person' },
                React.createElement("div", { className: 'name' }, quote.referer),
                React.createElement("div", { className: 'title' }, quote.titleAndCompany)))));
}
